module.exports = __webpack_public_path__ + "static/img/introduceCType2.ad43f1d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceCType2.png
// module id = mtlm
// module chunks = 0